var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { organizationEntityName } from '../../../../backend/features/organizations/shared';
import { StorageClient } from '@juvare/platform-sdk-js/StorageClient';
export function getOrganizationMap(organizations) {
    return __awaiter(this, void 0, void 0, function* () {
        const storageClient = new StorageClient(organizationEntityName);
        const result = yield storageClient.list({
            filter: [{ id: organizations, op: 'in' }],
        });
        return result.rows.reduce((orgMap, org) => {
            return Object.assign(Object.assign({}, orgMap), { [org.id]: org });
        }, {});
    });
}
